import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import {
    getElectricityPurchasedPerGroup,
    getRenewableEnergyPerGroup
} from '../../../../../../../actions/carbonfootprint-rework/06-dashboard/01-dashboard';
import { DataAccordion } from '../../../../../../shared-components/DataAccordion';
import GraphMainHeader from '../../../shared-components/GraphMainHeader';
import GraphSubHeader from '../../../shared-components/GraphSubHeader';
import GraphPairForGroups from '../../../shared-components/GraphPairForGroups';


export const ScopeTwoConsumptionOverview = ({ openAccordion, changeAccordion, company, year, title, companyName, groupArray }) => {
    const dispatch = useDispatch();
    //only one type in scope two overview
    const accordionName = 'Scope Two Consumption Overview'

    const electricityPurchasedPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.electricityPurchasedPerGroup?.data?.graph);
    const electricityPurchasedPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.electricityPurchasedPerGroup?.data?.pie);

    const renewableEnergyPerGroupGraph = useSelector((state) => (state.carbonFootprintDashboardReducer.renewableEnergyPerGroup?.data?.graph));
    const renewableEnergyPerGroupPie = useSelector((state) => (state.carbonFootprintDashboardReducer.renewableEnergyPerGroup?.data?.pie));

    useEffect(() => {
        if (openAccordion === accordionName && company && year) {
            dispatch(getElectricityPurchasedPerGroup(company, year));
            dispatch(getRenewableEnergyPerGroup(company, year));
        }
    }, [dispatch, openAccordion, company, year])

    return (
        // defaultExpanded
        <DataAccordion
            title={title}
            show={openAccordion === accordionName}
            handleChange={() => changeAccordion(accordionName)}
        >
            <Grid container >
                {/* Overview charts */}
                <GraphMainHeader>Energy Purchased {year}</GraphMainHeader>

                <GraphSubHeader>Electricity Purchased</GraphSubHeader>
                <GraphPairForGroups
                    barGraphData={electricityPurchasedPerGroupGraph}
                    pieChartData={electricityPurchasedPerGroupPie}
                    year={year}
                    companyName={companyName}
                    groupArray={groupArray}
                    type="Electricity Purchased"
                    unit={'kWh'}
                />

                <GraphSubHeader>Renewable Energy Consumed</GraphSubHeader>
                <GraphPairForGroups
                    barGraphData={renewableEnergyPerGroupGraph}
                    pieChartData={renewableEnergyPerGroupPie}
                    year={year}
                    companyName={companyName}
                    groupArray={groupArray}
                    type='Renewable Energy Consumed'
                    unit={'kWh'}
                />
            </Grid>
        </DataAccordion>
    )
}
